import { createRef, memo, useCallback, useEffect, useState } from "react";

import Create from "./Create";
import NoTicket from "./NoTicket";
import HeadingV2 from "../HeaderV2";
import List, { Ticket } from "./List";
import { getOwnTickets } from "../../utilities/Response";
import ConnectivityIssue from "../Layout/ConnectivityIssue";
import CircularProgress from '@mui/material/CircularProgress';
import Detail from "./Detail";
import ErrorComponent from '../KnowledgeBase/Error';
import { useSelector } from "react-redux";

const Tickets = (props: { design: any }) => {

  const [isError, setIsError] = useState(false);
  const [loading, setLoader] = useState<boolean>(true);
  const [tickets, setTickets] = useState<Ticket[]>([]);
  const [isCreatingTicket, setIsCreatingTicket] = useState(false);
  const environment = useSelector((state: any) => state?.environment);
  const [postMessageRecieved, setPostMessageRecieved] = useState(false);
  const [ticketDetails, setTicketDetails] = useState<Ticket | undefined>(undefined);
  const [userMeta, setUserMeta] = useState<{ name: string, email: string }>({ name: '', email: '' });

  useEffect(() => {
    (window as any).notesRef = createRef();
  }, []);

  useEffect(() => {
    setUserMeta(value => ({ ...value, email: environment.ticketsEmail }))
  }, [environment.ticketsEmail]);

  const onBackClick = () => {
    setLoader(true);
    getHubspotTickets();
    setIsCreatingTicket(false);
    setTicketDetails(undefined);
  }

  const getHubspotTickets = useCallback(() => {    
    if (userMeta.email) {
      setLoader(true);
      getOwnTickets(userMeta)
        .then((tickets: any) => {

          if (!tickets || (tickets.name && tickets.name === 'AxiosError')) {
            throw new Error('Failed');
          }
          setTickets(tickets)
        })
        .catch(err => {
          console.log(err);
          setIsError(true);
        })
        .finally(() => setLoader(false));
    } else {
      setLoader(false);
    }

  }, [userMeta]);

  useEffect(() => {
    getHubspotTickets()
  }, [getHubspotTickets])

  const createNewTicket = useCallback(() => {
    setIsCreatingTicket(true);
  }, []);


  useEffect(() => {
    const messageHandler = (event: any) => {
      if (event.data.origin === 'BotPenguin') {
        if (event.data.action === 'getRequestedUserMeta' && !userMeta.email) {
          setUserMeta(event.data.payload);
          setPostMessageRecieved(true);
        }
      }
    }
    window.addEventListener('message', messageHandler);

    let timeout: any;
    if (!userMeta.email && !postMessageRecieved) {

      window.parent.postMessage({
        origin: 'BotPenguin',
        action: 'requestingUserMeta'
      }, '*');
    }

    // Only for dev purpose
    // if (process.env.NODE_ENV === 'development') {
    //   window.postMessage({
    //     origin: 'BotPenguin',
    //     action: 'getRequestedUserMeta',
    //     payload: { name: 'BP TEST', email: 'divyansh@relinns.com' }
    //   }, '*');
    // }

    return () => {
      window.removeEventListener('message', messageHandler);

      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [userMeta.email, postMessageRecieved]);

  return (
    <>
      <div className={`flex flex-col justify-start rounded-t-2xl font-mRegular min-w-96 px-4 pt-4 h-full overflow-hidden`} style={{ backgroundColor: props?.design?.backgroundColor }} id="chatWindow">
        <div id='ele-65' className="h-16 max-h-20 rounded-xl"><HeadingV2 type="Tickets" backMethod={onBackClick} showBack={isCreatingTicket || !!ticketDetails} /></div>

        {
          loading
            ? <div id='ele-66' className="flex items-center justify-center h-full"><CircularProgress /></div>
            : isError
              ? <><ErrorComponent type="Tickets" /></>
              : <>

                {!tickets.length && !isCreatingTicket &&
                  <div id='ele-67' className="h-full"><NoTicket createNewTicket={createNewTicket} /></div>
                }

                {!!tickets.length && !isCreatingTicket && !ticketDetails &&
                  <div id='ele-75' className="flex-grow overflow-auto relative hide-scrollbar">
                    <List
                      setTicketDetails={setTicketDetails}
                      createNewTicket={createNewTicket}
                      openTickets={tickets.filter(t => t.status !== 'CLOSED')}
                      closedTickets={tickets.filter(t => t.status === 'CLOSED')}
                    />
                  </div>
                }

                {!!tickets.length && !isCreatingTicket && ticketDetails &&
                  <div id='ele-99' className="flex-grow overflow-auto hide-scrollbar" ref={(window as any).notesRef}>
                    <Detail ticket={ticketDetails} />
                  </div>
                }

                {!!isCreatingTicket &&
                  <div  id='ele-307' className="flex-grow overflow-auto relative">
                    <Create backMethod={onBackClick} />
                  </div>
                }

                <div className="position-fixed"> <ConnectivityIssue /> </div>
              </>
        }

      </div>
    </>
  );
}

export default memo(Tickets);

